import type { ReactNode } from "react";

type ControlButtonProps = {
  children: ReactNode;
  hiddenOnSmallScreen?: boolean;
  label: string;
  onClick: () => void;
};

export default function ControlButton({ children, hiddenOnSmallScreen, label, onClick }: ControlButtonProps) {
  return (
    <button
      type="button"
      className={`cursor-pointer text-gray-400 transition-colors hover:text-white ${hiddenOnSmallScreen ? "hidden lg:block" : ""}`}
      onClick={onClick}
      aria-label={label}
    >
      {children}
    </button>
  );
}
